<template>
    <DashboardLayout>

        <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
            <p class="mb-0 main-identifier fw-semibold">Budget</p>
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
            <p class="mb-0 sub-identifier">Search MDA Line Item</p>
        </div>

        <div class="d-flex justify-content-center">

            <div class="form-outer">
                <form @submit.prevent="handleSubmit">
                    <div class="crud-form position-relative">

                        <div class="form-inner">
                            <div class="form-header d-flex justify-content-between align-items-center">
                                <h1 class="mb-0">Search MDA Line Item </h1>
                            </div>

                        <div class="form-body">
                            <div class="row mt-2 mb-3">
                                <div class="col-md-12 row form-group position-relative floating-label-group">
                                  <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Year</label></div>
                                  <div class="col-md-9 input-right">
                                    <select class="form-select" v-model="form.year" required>
                                        <option value="" disabled>Select Year</option>
                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                    </select>
                                  </div>
                                </div>

                                <div class="col-md-12 row form-group position-relative floating-label-group">
                                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="subsector" class="form-label">M.D.A</label></div>
                                    <div class="col-md-9 input-right">
                                        <select class="form-select" required>
                                            <option value="">- Select MDA -</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center ">
                                <button class="submit-btn" type="submit" >Submit</button>
                            </div>
                        </div>
                        </div>


                    </div>
                </form>
            </div>
        </div>

    </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'

const root_api_url = process.env.VUE_APP_API_ROOT_URL

// Reactive form data
const form = reactive({
  mdaName: '',
  organizationCode: '',
  economicLineItemId: '',
  year:''
})

const currentYear = new Date().getFullYear();
const years = ref(Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i));


const fetchEconomicLineItems = async () => {
  try {
    const response = await axios.get(`${root_api_url}/eli`)
    // subsectors.value =
    response.data
  } catch (err) {
    console.error('Error fetching economic line items:', err)
    // alert('Failed to load economic line items.')
  }
}


const handleSubmit = async () => {
  try {
    const result = await axios.post(`${root_api_url}/mda`, {
      name: form.mdaName,
      orgCode: form.organizationCode,
      economicLineItemId: form.economicLineItemId
    })

    if (result.status === 201) {
      alert(`MDA Created:\nMda Name: ${form.mdaName}\nOrganization Code: ${form.organizationCode}\nSubsector Id: ${form.economicLineItemId}`)
      form.mdaName = ''
      form.organizationCode = ''
      form.economicLineItemId = ''
    }
  } catch (err) {
    console.error('Submission error:', err)
    alert('Failed to create MDA: ' + (err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || err.message))
  }
}

onMounted(() => {
  fetchEconomicLineItems,
    document.title = "Search MDA Line Item"
})


</script>
